module.exports = __webpack_public_path__ + "img/Presentación_personal.e05e4c7b.svg";